import React from 'react';

export default function TooltipDetails(props) {
  const { details } = props;
  if (!details) return '';

  const urls = details.source_urls || [];

  return (
    <>
      <div>
        {details.message}
        {urls.length ? ':' : ''}
      </div>
      {
        urls.map((url) => (
          <p>
            <a
              href={url}
              key={url}
              rel="noreferrer"
              style={{ textDecoration: 'underline', cursor: 'pointer', color: 'inherit' }}
              target="_blank"
            >
              See reason
            </a>
          </p>
        ))
      }
    </>
  );
}
